import { categories } from "@/mocks/homeData";

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-12 max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-semibold text-foreground-950 mb-4">
            Explore Product Categories
          </h2>
          <p className="text-foreground-500 text-base max-w-xl mx-auto">
            Browse all 14 curated categories from the <strong>mulebuy spreadsheet</strong> directory — each linking to verified product lists.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-2xl overflow-hidden aspect-[4/3] cursor-pointer"
            >
              <img
                src={cat.image}
                alt={`${cat.name} category in mulebuy spreadsheet directory`}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <div className="flex items-center gap-2 mb-1">
                  <span className="w-6 h-6 rounded-md bg-background-50/90 flex items-center justify-center">
                    <i className={`${cat.icon} text-accent-600 text-xs`}></i>
                  </span>
                </div>
                <span className="text-background-50 font-semibold text-sm md:text-base">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}